import { _js } from '@ifixit/utils/localize';
import { cn } from '@ifixit/ui/lib/utils';

/**
 * The Creative Commons contributor-licensing notice, the v2 counterpart to
 * v1's disclaimer.phtml. Kept quiet as a footnote: it's legal text, not part
 * of the editing flow. The two links are fixed constants, so the localized
 * string is safe to set as HTML (the same way v1 built it with the `a()`
 * helper).
 */
export function LicenseDisclaimer({ className = 'mt-6' }: { className?: string }) {
   const html = _js(
      'Your contributions are %1licensed%3 under the open source %2Creative Commons%3 license.',
      '<a href="/Info/Licensing" target="_blank" rel="noreferrer">',
      '<a href="http://creativecommons.org/licenses/by-nc-sa/3.0/" target="_blank" rel="noreferrer">',
      '</a>'
   );
   return (
      <p
         className={cn(
            'text-xs text-gray-400 [&_a]:underline [&_a:hover]:text-gray-600',
            className
         )}
         dangerouslySetInnerHTML={{ __html: html }}
      />
   );
}
